import { Path } from '../types';

export default function isPathEqual(path1: Path, path2: Path): boolean {
  if (path1.length !== path2.length) return false;
  return path1.every((p, i) => p === path2[i]);
}
